import React from 'react';
import { CalendarDays, CheckSquare, Shield, User, Archive } from 'lucide-react';

interface MemberSidebarProps {
    activeView: string;
    onViewChange: (view: string) => void;
    isOpen: boolean;
}

const MemberSidebar: React.FC<MemberSidebarProps> = ({ activeView, onViewChange, isOpen }) => {
    const navItems = [
        { id: 'PLAN', label: 'Plan', icon: <CalendarDays size={20} /> },
        { id: 'WORK', label: 'Action Centre', icon: <CheckSquare size={20} /> },
        { id: 'HISTORY', label: 'History', icon: <Archive size={20} /> },
        { id: 'VAULT', label: 'Vault', icon: <Shield size={20} /> },
        { id: 'IDENTITY', label: 'Identity', icon: <User size={20} /> },
    ];

    return (
        <div className={`member-sidebar ${isOpen ? 'expanded' : 'collapsed'}`}>
            <nav className="member-sidebar-nav">
                {navItems.map((item) => (
                    <button
                        key={item.id}
                        data-testid={`NAV_member_sidebar_${item.id}`}
                        className={`member-nav-item ${activeView === item.id ? 'active' : ''}`}
                        onClick={() => onViewChange(item.id)}
                        title={!isOpen ? item.label : undefined}
                    >
                        <span className="member-nav-icon">{item.icon}</span>
                        {isOpen && <span className="member-nav-label">{item.label}</span>}
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default MemberSidebar;
